<script>
import Ajax from '@/ajax';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  data () {
    return {
      language: 'en'
    }
  },
  watch: {
  },
  methods: {
    handleLanguageChange (language) {
      Ajax({
        url: '/api/user/push-preferred-language/update',
        method: 'get',
        params: {
          preferredLanguage: language
        }
      }).then((res) => {
        this.$message.success(this.$t('更新成功'))
      })
        .catch((err) => {
          this.$message.error(err || this.$t('服务器开小差'))
        })
    },
    getEmail () {
      let userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.email : '';
    }
  }
}
</script>

<template>
  <el-dialog :title="$t('请选择推送语言(接收业务通知)')" :visible.sync="dialogVisible"
    @update:visible="$emit('update:visible', $event)" width="650px">
    <el-radio-group v-model="language" @input="handleLanguageChange">
      <el-radio label="en">{{ $t('英文') }}</el-radio>
      <el-radio label="zh">{{ $t('中文') }}</el-radio>
    </el-radio-group>
  </el-dialog>
</template>

<style lang="scss"></style>
